import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { errMsg } from "../../../text_control/error-msg";
import { errSelDataMsg } from "../seller-data/seller-data.const";
import { DeleteSellerModalComponent } from "./delete-seller-modal/delete-seller-modal.component";
@Component({
  selector: "app-seller-data",
  templateUrl: "./seller-data.component.html",
  styleUrls: ["./seller-data.component.scss"],
})
export class SellerDataComponent implements OnInit {
  sellerData: any;
  body = {
    getpagination: {
      pageid: "1",
      filter: "",
    },
  };
  page = 1;
  showPage = false;
  searchSeller: any = "";
  firstPage = true;
  prevPage = true;
  nextPage = false;
  lastpage = false;
  allPages: number;
  rowLimit = 1;
  loading = false;
  timer = null;
  constructor(
    private router: Router,
    private apiService: ApiserviceService,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private appService: AppService,
    private modalController: ModalController
  ) {}

  async ngOnInit() {
    this.body = {
      getpagination: {
        pageid: this.page ? String(this.page) : "1",
        filter: this.searchSeller,
      },
    };
    // this.initialSellerData();
  }

  sellerDataValidate(response) {
    if (typeof response !== "object") {
      return { result: false, errMsg: errSelDataMsg.typeErr };
    }
    if (!response.hasOwnProperty("data")) {
      return { result: false, errMsg: errSelDataMsg.typeErr };
    }
    if (response.statusCode !== 200) {
      return { result: false, errMsg: response.statusMessage };
    }
    return { result: true };
  }

  async initialSellerData() {
    console.log("IN initialSellerData");
    const response = await this.apiService._post(
      this.apiService.apiUrl + this.apiService.getSellerLists,
      this.body
    );
    console.log("response", response);
    let valid = this.sellerDataValidate(response);
    try {
      if (!valid.result) {
        this.ErrorMsg(valid.errMsg);
        this.loading = false;
      } else {
        this.sellerData = response.data;
        this.allPages = Math.ceil(response.count / response.row_limit);
        console.log("All page", this.allPages);
        this.showPage = true;
        this.rowLimit = response.row_limit;
      }
    } catch (e) {
      this.loading = false;
      this.showPage = false;
      // this.ErrorMsg(errMsg.error)
    }
  }

  editCustomerData($event) {
    this.router.navigate(["/seller-detail"], { queryParams: { id: $event } });
  }

  addNewSeller() {
    this.router.navigate(["/seller-add"]);
  }

  async search() {
    this.sellerData = null;
    this.loading = false;
    this.showPage = false;
    if (!this.searchSeller) {
      return;
    }
    this.page = 1;
    this.loading = true;
    clearTimeout(this.timer);
    const data = {
      getpagination: {
        pageid: "1",
        filter: this.searchSeller,
      },
    };
    this.timer = setTimeout(async () => {
      const response = await this.apiService._post(
        this.apiService.apiUrl + this.apiService.getSellerLists,
        data
      );
      try {
        if (response.statusCode === 200) {
          this.sellerData = response.data;
          this.rowLimit = response.row_limit;
          this.allPages = Math.ceil(response.count / this.rowLimit);
          this.firstPage = this.prevPage = true;
          this.showPage = true;
          this.nextPage = this.lastpage = this.allPages === 1 ? true : false;
        } else {
          this.showPage = false;
          this.loading = false;
          this.ErrorMsg(response.statusMessage);
        }
      } catch (e) {
        this.showPage = false;
        this.loading = false;
        this.ErrorMsg(errMsg.error);
      }
    }, 1500);
  }

  async getFirst() {
    const temp = this.page;
    const tempData = this.sellerData;
    this.sellerData = null;
    this.page = 1;
    const body = {
      getpagination: {
        pageid: "1",
        filter: this.searchSeller,
      },
    };
    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.getSellerLists, body)
        .then(async (res) => {
          console.log("[------res data pagination -----------]", res);
          if (res.statusCode === 200) {
            this.sellerData = res.data;
            this.prevPage = this.firstPage = true;
            this.nextPage = this.lastpage = false;
            this.rowLimit = res.row_limit;
          } else if (res.statusCode === 204) {
            this.showPage = false;
            this.sellerData = tempData;
            this.page = temp;
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              header: "Error pagination",
            });
            await alert.present();
            alert.dismiss();
          } else {
            this.showPage = false;
            this.sellerData = tempData;
            this.page = temp;
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.showPage = false;
      this.loading = false;
      this.ErrorMsg(errMsg.error);
    }
  }
  async getLast() {
    const temp = this.page;
    this.page = this.allPages;
    const tempData = this.sellerData;
    this.sellerData = null;
    console.log("Page", this.page);
    const body = {
      getpagination: {
        pageid: `${this.page}`,
        filter: this.searchSeller,
      },
    };
    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.getSellerLists, body)
        .then(async (res) => {
          console.log("[------res data pagination -----------]", res);
          if (res.statusCode === 200) {
            this.sellerData = res.data;
            this.prevPage = this.firstPage = false;
            this.nextPage = this.lastpage = true;
            this.rowLimit = res.row_limit;
          } else if (res.statusCode === 204) {
            this.showPage = false;
            this.sellerData = tempData;
            this.page = temp;
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              header: "Error pagination",
            });
            await alert.present();
            alert.dismiss();
          } else {
            this.showPage = false;
            this.sellerData = tempData;
            this.page = temp;
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.showPage = false;
      this.loading = false;
      this.ErrorMsg(errMsg.error);
    }
  }
  async getPage(numPage) {
    const temp = this.page;
    this.page += numPage;
    const tempData = this.sellerData;
    this.sellerData = null;
    console.log(this.page);
    const body = {
      getpagination: {
        pageid: `${this.page}`,
        filter: this.searchSeller,
      },
    };
    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.getSellerLists, body)
        .then(async (res) => {
          console.log("[------res data pagination -----------]", res);

          if (res.statusCode === 200) {
            this.sellerData = res.data;
            this.prevPage = this.firstPage = this.page === 1 ? true : false;
            this.nextPage = this.lastpage =
              this.page === this.allPages ? true : false;
          } else if (res.statusCode === 204) {
            this.showPage = false;
            this.sellerData = tempData;
            this.page = temp;
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              header: "Error pagination",
            });
            await alert.present();
            alert.dismiss();
          } else {
            this.showPage = false;
            this.sellerData = tempData;
            this.page = temp;
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.showPage = false;
      this.loading = false;
      this.ErrorMsg(errMsg.error);
    }
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  async presentDeleteModal(id, name, taxId) {
    const modal = await this.modalController.create({
      component: DeleteSellerModalComponent,
      cssClass: "my-custom-class",
      componentProps: {
        sellerId: id,
        sellerName: name,
        taxId: taxId,
      },
    });

    modal.onDidDismiss().then(async (res) => {
      if(res.data?.confirm) {
        this.search();
      }
      // this.initialSellerData();
      // this.router.navigate(['/credit-note-preview'])
      // this.appService.setActive(4);
    });
    return await modal.present();
  }
}
